//
import { initializeApp } from 'firebase/app';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBPVGY3mNv1Z4M1lBdZIdis4ChlgJPGrPI',
  authDomain: 'nassfoods-b0570.firebaseapp.com',
  projectId: 'nassfoods-b0570',
  storageBucket: 'nassfoods-b0570.firebasestorage.app',
  messagingSenderId: '748236667631',
  appId: '1:748236667631:web:70cdbb7e46a8706301391a',
  measurementId: 'G-XQMNJ7Y281',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export { app };
